import styled from 'styled-components'

const MyDiv = styled.div`
.react-calendar {
    font-family: 'Poppins', sans-serif;
    width: 220px;
    max-width: 100%;
    font-size: 12px;
    border: none;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  }

  .react-calendar__tile {
    padding: 6px 0;
  }

  .react-calendar__navigation button {
    min-width: 28px;
    font-size: 12px;
  }

  .react-calendar__month-view__days__day--weekend {
    color: #ff6b6b;
  }
 .card_box {
  background: white;
  padding: 5px 10px;
  border-radius: 16px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.card-wrapper{
    background: #EEF3FB;
    border-radius: 8px;
}
.card_label {
  color: #23272E;
  position: relative;
  right: 25px;
}

.card_value {
font-size: 36px;
  color: #23272E;
}

`
export default MyDiv
